import React from 'react';
import PropTypes from 'prop-types';
import Theme from "./Theme.js";
/** 
 * React class to render a block of text 
 * @property {string} className - css class to be applied to this component 
 * @property {string} variant - Theme variant name to be added to the component 
 * */
import { jsx as _jsx } from "react/jsx-runtime";
class TextArea extends React.Component {
  static contextType = Theme.Context;
  static propTypes = {
    className: PropTypes.string,
    variant: PropTypes.string
  };
  static defaultProps = {
    className: null,
    variant: null
  };
  onChange = e => {
    const {
      eventData,
      onChange
    } = this.props;
    if (onChange) {
      onChange({
        value: e.target.value,
        data: eventData
      });
    }
  };
  render() {
    const theme = this.context;
    // eslint-disable-next-line no-unused-vars
    const {
      className,
      variant,
      value,
      onChange,
      eventData,
      disabled,
      readonly,
      hint,
      placeholder,
      layoutOptions,
      ...rest
    } = theme.props('TextArea', this.props);
    const dis = disabled || readonly;
    const ph = hint || placeholder;
    return /*#__PURE__*/_jsx("textarea", {
      className: theme.classes('TextArea', 'textArea', variant, className),
      onChange: this.onChange,
      onInput: this.onInput,
      readOnly: dis,
      placeholder: ph,
      value: value || '',
      ...rest
    });
  }
}
export default TextArea;